import { string, object } from 'yup';

import { message } from 'shared/helpers/constants/notes/createNoteConstants';

export const CreateNoteFormYup = object().shape({
  note: string().trim(message.INVALID_NOTE).max(255, message.INVALID_NOTE_LENGTH()),
});
